<h2 mat-dialog-title class="dam-title">{{ 'delete_account_modal.title' | translate }}</h2>

<mat-dialog-content class="dam-content">
  <p class="dam-warning">{{ 'delete_account_modal.warning' | translate }}</p>

  <p class="dam-info">
    {{ 'delete_account_modal.info' | translate }}
    <a routerLink="/account-deletion" (click)="cancel()">
      {{ 'delete_account_modal.learn_more' | translate }}
    </a>
  </p>

  <label class="dam-label" for="dam-confirm">
    {{ 'delete_account_modal.confirm_instruction' | translate: { word: confirmationWord } }}
  </label>
  <input
    id="dam-confirm"
    type="text"
    class="dam-input"
    autocomplete="off"
    [attr.placeholder]="confirmationWord"
    [(ngModel)]="typedConfirmation"
  />
</mat-dialog-content>

<mat-dialog-actions class="dam-actions" align="end">
  <button type="button" class="dam-btn dam-btn--ghost" (click)="cancel()">
    {{ 'delete_account_modal.cancel' | translate }}
  </button>
  <button
    type="button"
    class="dam-btn dam-btn--danger"
    [disabled]="!canDelete"
    (click)="confirm()"
  >
    {{ 'delete_account_modal.confirm' | translate }}
  </button>
</mat-dialog-actions>
